import { Header as HeaderCommon } from '@widget/toolbox/components/HeaderCommon';

import { logo, navigationLinks } from './navigationConfig';

import type { THeaderSettings } from '@widget/api/storyblok';

interface HeaderProps {
  headerSettings: THeaderSettings;
}

export const Header = ({ headerSettings }: HeaderProps): JSX.Element => {
  return (
    <HeaderCommon
      hideNavigation={false}
      navItems={headerSettings?.navItems || navigationLinks}
      logos={[logo]}
      phoneCTA={headerSettings.phoneCta}
      loginLink={headerSettings.loginLink}
      callbackCta={headerSettings.callbackCta}
    />
  );
};
